import { FC } from 'react';

import { IconLogin } from '@purpur/library/icon/login';

import { useTranslations } from '@telialt/common-cms/src/useTranslations';
import { TeliaSegment, useSegment } from '@telialt/utils/src/segment';
import { useUserData } from '@telialt/utils/src/SSO/useUserData';

import { BenefitItem, BenefitsList, LoginLink, ProductLoginCtaContainer, TitleRow } from './ProductLoginCta.styles';
import { PRODUCT_LOGIN_CTA_TEST_ID } from './test-ids';

const LOGIN_HREF = '/mano?source=i';

const ID_TITLE = 'product-login-cta--header';

export const ProductLoginCta: FC = () => {
    const { t } = useTranslations();
    const { userData } = useUserData();
    const segment = useSegment();

    if (segment !== TeliaSegment.B2c || userData !== null) {
        return null;
    }

    return (
        <ProductLoginCtaContainer data-test={PRODUCT_LOGIN_CTA_TEST_ID.CONTAINER}>
            <TitleRow id={ID_TITLE}>
                <IconLogin size="md" aria-hidden={true} />
                {t['eshop.product_page.login_cta.title']}
            </TitleRow>
            <BenefitsList aria-labelledby={ID_TITLE}>
                <BenefitItem>{t['eshop.product_page.login_cta.benefit_1']}</BenefitItem>
                <BenefitItem>{t['eshop.product_page.login_cta.benefit_2']}</BenefitItem>
            </BenefitsList>
            <LoginLink
                href={LOGIN_HREF}
                variant="secondary"
                showIcon={true}
                fullWidth={true}
                size="md"
                data-test={PRODUCT_LOGIN_CTA_TEST_ID.BUTTON}
            >
                {t['eshop.product_page.login_cta.button']}
            </LoginLink>
        </ProductLoginCtaContainer>
    );
};
